import {AdcConjugationMethod} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ConjugationSite} from 'molbio/adcs/conjugation-sites/AdcConjugationSiteConstants';

export interface FindConjugationSiteCandidatesInput {
  antibodyId: string;
  conjugationMethod: AdcConjugationMethod;
}

export type ConjugationSiteCandidatesResult =
  | {supported: true; candidates: Array<ConjugationSite>}
  | {supported: false};

/** Fake engineered cysteine sites spread across heavy- and light-chain constant domains. */
export const PLACEHOLDER_ENGINEERED_CYSTEINE_CONJUGATION_SITES: ReadonlyArray<ConjugationSite> = [
  {domainLabel: 'CH1', residueIndex: 0},
  {domainLabel: 'CH2', residueIndex: 8},
  {domainLabel: 'CH3', residueIndex: 101},
  {domainLabel: 'CL', residueIndex: 97},
];

/**
 * PLACEHOLDER: returns the residues on an antibody where a payload could attach using the given conjugation
 * method.
 *
 * The site-finding module does not exist yet, so this ignores the antibody and returns a fixed list of fake
 * sites for engineered cysteine conjugation, whose sites are chosen by design. Every other method is reported as
 * unsupported.
 *
 * TODO(BNCH-171153 follow-up): replace with the real site finder once it exists, most likely a GraphQL query.
 */
export async function findConjugationSiteCandidates({
  conjugationMethod,
}: FindConjugationSiteCandidatesInput): Promise<ConjugationSiteCandidatesResult> {
  // Stands in for the server call, so callers already handle this asynchronously.
  await Promise.resolve();
  if (conjugationMethod !== AdcConjugationMethod.ENGINEERED_CYSTEINE) {
    return {supported: false};
  }
  return {supported: true, candidates: [...PLACEHOLDER_ENGINEERED_CYSTEINE_CONJUGATION_SITES]};
}
